/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M20 12l-10 0", "key": "svg-0" }], ["path", { "d": "M20 12l-4 4", "key": "svg-1" }], ["path", { "d": "M20 12l-4 -4", "key": "svg-2" }], ["path", { "d": "M4 4l0 16", "key": "svg-3" }]];
const IconArrowBarRight = createReactComponent("outline", "arrow-bar-right", "ArrowBarRight", __iconNode);

export { __iconNode, IconArrowBarRight as default };
//# sourceMappingURL=IconArrowBarRight.mjs.map
